import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=13f9e6c0"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"
import style0 from "./coupon.vue?vue&type=style&index=0&id=13f9e6c0&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports